import React, { Component } from "react";
import ProductPickerSelectedDetails from "./product-picker-selected-details";
import IconArrow from "ReactComponents/Shared/Icons/icon-arrow";
import { productPickerComposer } from "ReactReducers/ProductPicker/product-picker-composer";
import propTypes from "prop-types";

class ProductPickerSelectedTypelist extends Component {
    constructor(props) {
        super(props);

        this.selectConfig = this.selectConfig.bind(this);
    }

    selectConfig(e, index) {
        this.props.setSalesConfigIndex(index);
    }

    render() {
        const product = this.props.product;
        const productConfigs = product.PriceConfigurations;
        const hasMoreProductConfigs = productConfigs.length !== 1;
        const showList = this.props.salesConfigIndex === null;
        const current = this.props.salesConfigIndex || 0;

        const showTypeList = () => {
            return (
                <div className="product-picker-typelist__list">
                    {productConfigs.map((conf, index) => {
                        return (
                            <div key={index} className="product-picker-typelist__item">
                                <div className="left">
                                    <strong className="product-picker-typelist__item__Label">
                                        {conf.LicenseLabel || "!LicenseLabel"}
                                    </strong>
                                    <span className="product-picker-typelist__item__summary">
                                        {conf.ConfigurationSummary || "!ConfigurationSummary"}
                                    </span>
                                </div>
                                <div className="right">
                                    <button
                                        type="button"
                                        className="link-button"
                                        onClick={e => {
                                            this.selectConfig(e, index);
                                        }}
                                    >
                                        {conf.ConfigurationSelect}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        };

        const showSelectedType = () => {
            return (
                <div className="product-picker-typelist__selection">
                    {hasMoreProductConfigs ? (
                        <div className="product-picker-typelist__navigation">
                            <button
                                type="button"
                                className="link-button"
                                onClick={e => {
                                    this.selectConfig(e, null);
                                }}
                            >
                                <IconArrow direction="left" />
                            </button>
                        </div>
                    ) : (
                        ""
                    )}
                    <div className="product-picker-typelist__content">
                        {productConfigs.map((conf, index) => {
                            const hasContent =
                                conf.AccessText || conf.AccessPeriodText || conf.AccessRenewText;

                            if (
                                (hasContent || conf.ShowClassOptions) &&
                                (current == index || !hasMoreProductConfigs)
                            ) {
                                return (
                                    <ProductPickerSelectedDetails
                                        key={index}
                                        configs={conf}
                                        product={this.props.product}
                                        labels={this.props.labels}
                                    />
                                );
                            }
                        })}
                    </div>
                </div>
            );
        };

        return (
            <div className="product-picker-typelist">
                {showList && hasMoreProductConfigs ? showTypeList() : showSelectedType()}
            </div>
        );
    }
}

ProductPickerSelectedTypelist.propTypes = {
    product: propTypes.object.isRequired
};

export default productPickerComposer(ProductPickerSelectedTypelist);
